<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import NProgress from 'nprogress'
  // Loading some plugin css asynchronously
  import('sweetalert2/dist/sweetalert2.css')
  import('vue-notifyjs/themes/default.css')
  import('nprogress/nprogress.css')
  export default {
    created: function () {
      this.$http.interceptors.request.use(function (config) {
        NProgress.start()
        return config
      })

      this.$http.interceptors.response.use(
        function (response) {
          NProgress.done()
          return response
        },
        (error) => {
          NProgress.done()
          this.$notify({
            component: {
              template: `<span><b>Connection Error</b> - Could not connect to the Providence First servers, check your connection or try again later.</span>`
            },
            icon: 'ti-alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          console.log(error)
        }
      )
    }
  }
</script>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue